import React from "react";
import "./Tag.scss";

/**
 * neutral = grey · ok = green (Active, Paid, Confirmed) · warn = amber (Pending, Scheduled) · danger = red (Hidden,
 * Cancelled, Banned) · info = blue tint · spark = orange tint · brand = blue tint · live = solid red with a dot
 * · solid-spark / solid-brand = solid orange / blue · yellow = beach volleyball
 */
export type TagTone =
  | "neutral"
  | "ok"
  | "warn"
  | "danger"
  | "info"
  | "spark"
  | "brand"
  | "live"
  | "solid-spark"
  | "solid-brand"
  | "yellow";

export type TagProps = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: TagTone;
  icon?: React.ReactNode;
  /** md is a little larger, for headers */
  size?: "sm" | "md";
};

/** A small slanted label: statuses, types, counts. */
export function Tag({ tone = "neutral", icon, size = "sm", className, children, ...rest }: TagProps): React.JSX.Element {
  return (
    <span {...rest} className={["ui-tag", `ui-tag--${tone}`, `ui-tag--${size}`, className].filter(Boolean).join(" ")}>
      {icon ? <span className="ui-tag__icon">{icon}</span> : null}
      {children}
    </span>
  );
}

export default Tag;
